import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

interface QRCodeSvgProps {
  value: string;
  size?: number;
  fgColor?: string;
  bgColor?: string;
}

export const QRCodeSvg: React.FC<QRCodeSvgProps> = ({
  value,
  size = 210,
  fgColor = '#1B4332',
  bgColor = '#FFFFFF',
}) => {
  const [qrDataUrl, setQrDataUrl] = useState<string>('');

  useEffect(() => {
    if (!value) return;
    QRCode.toDataURL(value, {
      width: size,
      margin: 1,
      color: {
        dark: fgColor,
        light: bgColor,
      },
      errorCorrectionLevel: 'M',
    })
      .then((url) => setQrDataUrl(url))
      .catch((err) => console.error('QR Code generation error:', err));
  }, [value, size, fgColor, bgColor]);

  return (
    <div style={{
      display: 'inline-block',
      padding: '12px',
      backgroundColor: bgColor,
      borderRadius: '12px',
      boxShadow: '0 4px 14px rgba(0,0,0,0.06)',
      border: '1px solid #E2E8F0',
    }}>
      {qrDataUrl ? (
        <img
          src={qrDataUrl}
          alt="Luminous Break Pairing QR Code"
          width={size}
          height={size}
          style={{ display: 'block', imageRendering: 'pixelated' }}
        />
      ) : (
        <div style={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#FAF8F5',
          color: '#64748B',
          fontSize: '12px',
        }}>
          Generating QR Code...
        </div>
      )}
    </div>
  );
};
